module.exports = __webpack_public_path__ + "img/copon_10.23368268.png";